import { defineStore } from 'pinia';

export const useThemeStore = defineStore({
  id: 'theme',
  
  state: () => ({
    isDark: false,
  }),
  
  actions: {
    toggleDarkMode() {
      this.isDark = !this.isDark;
      // Save preference to localStorage
      localStorage.setItem('indiefy-theme', this.isDark ? 'dark' : 'light');
      // Update HTML and body classes for CSS selectors
      document.documentElement.classList.toggle('dark-theme', this.isDark);
      document.body.classList.toggle('body--dark', this.isDark);
    },
    
    setDarkMode(value) {
      this.isDark = value;
      // Save preference to localStorage
      localStorage.setItem('indiefy-theme', this.isDark ? 'dark' : 'light');
      // Update HTML and body classes for CSS selectors
      document.documentElement.classList.toggle('dark-theme', this.isDark);
      document.body.classList.toggle('body--dark', this.isDark);
    },
  },
});